import React, {useContext} from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import Link from '../Link';
import AppContext from '../../context'

const StyledSuggestions = styled.div`
  display: block;
  background-color: #fff;
  position: absolute;
  left: 0;
  width: 100%;
  padding: 15px;
  font-size: ${({theme}) => theme.typography.fontSize.fs3};
  line-height: ${({theme}) => theme.typography.lineHeight.lh3};
  box-shadow: -1px -1px 10px 0 rgba(0,0,0,.2);
  margin-top: 3px;
  border-radius: 3px;
`

const StyledSuggestionElement = styled.div`
  a {
    display: flex;
    align-items: center;
  }

  .suggestion {
    font-size: ${({theme}) => theme.typography.fontSize.fs3};
    line-height: ${({theme}) => theme.typography.lineHeight.lh3};
  
    &--category {
      justify-content: space-between;
    }
  }
  
  color: ${({theme}) => theme.colors.greyscale.black};
  padding: 8px 0 3px 0;
  b{
    color: ${({theme}) => theme.colors.primary.base};
  }
`

const TruncatedText = styled.span`
  max-width: 400px;
  text-overflow: ellipsis;
  height: 1.2em;
  white-space: nowrap;
  overflow: hidden;
`

const SearchHeader = styled.div`
  font-weight: bold;
  color: ${({theme}) => theme.colors.greyscale.black};
  margin-top: ${({hasMargin}) => hasMargin && '10px'};
`

const SearchImage = styled.img`
  max-height: 25px;
  margin-right: 15px;
  display: inline-block;
  vertical-align: middle;
`
const buildCategorySearchURL = (data) => {
  const url = '/esearch.htm#'
  let queryUrl = ''
  let parts;

  let categories = ''
  if (data) {
    parts = data.split('¦')
    queryUrl += `q=${parts[parts.length - 1].substr(1)}&catl=`
    parts.forEach((item) => {
      categories += `${item.substr(1)}>`
    })
    categories = categories.substr(0, categories.length - 1)
    queryUrl += `${categories}&cats=${parts.length}${categories}`
  }
  return url + encodeURIComponent(queryUrl)
}

const getItemName = (name, string, separator) => {
  const parts = string.split('¦')
  if (parts.length > 1) return `${name} ${separator} ${parts[1].substr(1)}`;

  if (parts.length === 1) return `${name} ${separator} ${parts[0].substr(1)}`;

  return name
}

const checkSuggestions = (suggestions, term, translations) => {
  let layout;
  const categories = (cat) => {
    return <>
      <SearchHeader>{`${translations.get('shop.header.search.autocomplete.title.suggestion')} ${term}`}</SearchHeader>
      {cat.children.map(
        (d, i) => <StyledSuggestionElement key={`item-${i}`}>
          <Link bold={false} withPadding type="tertiary" href={buildCategorySearchURL(d.data.URL)} className="suggestion suggestion--category">
            <TruncatedText dangerouslySetInnerHTML={{__html: `${getItemName(d.data.SN_name, d.data.URL, translations.get('shop.header.search.autocomplete.separator'))}`}} />
            <span>{`(${d.data.Image})`}</span>
          </Link>
        </StyledSuggestionElement>
      )}
    </>
  }

  const products = (p) => {
    return <>
      <SearchHeader hasMargin>{translations.get('shop.header.search.autocomplete.title.products')}</SearchHeader>
      {
        p.children.map(
          (d, i) => <StyledSuggestionElement key={`item-${i}`}>
            <Link bold={false} withPadding type="tertiary" href={d.data.URL} className="suggestion">
              <SearchImage src={d.data.Image} alt="" />
              <TruncatedText dangerouslySetInnerHTML={{__html: d.data.SN_name}} />
            </Link>
          </StyledSuggestionElement>
        )
      }
    </>
  }

  const services = (serv) => {
    return <>
      <SearchHeader hasMargin>{translations.get('shop.header.search.autocomplete.title.services')}</SearchHeader>
      {
        serv.children.map(
          (d, i) => <StyledSuggestionElement key={`item-${i}`}>
            <Link bold={false} withPadding type="tertiary" href={d.data.URL} className="suggestion">
              <TruncatedText dangerouslySetInnerHTML={{__html: d.data.SN_name}} />
            </Link>
          </StyledSuggestionElement>
        )
      }
    </>
  }

  if (suggestions.length === 3) {
    layout = <>
      {categories(suggestions[0])}
      {products(suggestions[1])}
      {services(suggestions[2])}
    </>
  } else if (suggestions.length === 2) {
    layout = <>
      {categories(suggestions[0])}
      {products(suggestions[1])}
    </>
  } else if (suggestions.length === 1) {
    if (suggestions[0].text === 'article') {
      layout = <>
        {products(suggestions[0])}
      </>
    } else {
      layout = <>
        {categories(suggestions[0])}
      </>
    }
  }

  return layout
}

const SearchSuggestions = ({suggestions, term}) => {
  const {translations} = useContext(AppContext)
  return (
    <StyledSuggestions>
      {checkSuggestions(suggestions, term, translations)}
    </StyledSuggestions>
  )
}

SearchSuggestions.propTypes = {
  suggestions: PropTypes.arrayOf(PropTypes.object),
  term: PropTypes.string
}

SearchSuggestions.defaultProps = {
  suggestions: [{}],
  term: ''
}

export default SearchSuggestions
